/** @jsx h */
import { h } from 'preact'
import Spin from './icons/spin'
import clsx from 'clsx'

const Button = ({ onClick, className, children, disabled, loading }) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        `rcc-relative rcc-block rcc-uppercase rcc-tracking-widest rcc-text-xs rcc-px-12 rcc-py-4 rcc-cursor-pointer rcc-w-full rcc-border rcc-border-solid rcc-bg-white rcc-font-widget
        disabled:rcc-border-gray-very-light disabled:rcc-text-very-light disabled:rcc-cursor-not-allowed disabled:rcc-no-underline ${
          className || ''
        }`
      )}
      disabled={disabled}
    >
      {loading && <Spin classname='rcc-absolute rcc-right-3.5' />}
      {children}
    </button>
  )
}

export default Button
